import { render, staticRenderFns } from "./ModificarPrecios.vue?vue&type=template&id=bc1e398c&scoped=true&"
import script from "./ModificarPrecios.vue?vue&type=script&lang=js&"
export * from "./ModificarPrecios.vue?vue&type=script&lang=js&"
import style0 from "./ModificarPrecios.vue?vue&type=style&index=0&id=bc1e398c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1e398c",
  null
  
)

export default component.exports